import React from 'react';
import { ImageGridStyled } from '@atomic/mol.image-grid/image-grid.component.style';
export var ImageGrid = function (props) {
    var _a;
    return (React.createElement(ImageGridStyled, null, (_a = props.items) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (React.createElement("a", { key: item.source, href: item.href },
        React.createElement("img", { src: item.source, alt: item.alt }))); })));
};
